module.exports = __webpack_public_path__ + "static/img/share_poster.6e472f53.png";